export default __webpack_public_path__ + "static/media/cover2.713ecf61.png";